var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46919 12.5295C8.53894 12.5992 8.62144 12.654 8.71369 12.6923C8.80519 12.7305 8.90269 12.75 9.00019 12.75C9.09769 12.75 9.19519 12.7305 9.28669 12.6923C9.37894 12.654 9.46144 12.5992 9.53119 12.5295L11.7804 10.2802C12.0737 9.987 12.0737 9.513 11.7804 9.21975C11.4872 8.9265 11.0132 8.9265 10.7199 9.21975L9.75019 10.1895V3C9.75019 2.586 9.41494 2.25 9.00019 2.25C8.58544 2.25 8.25019 2.586 8.25019 3V10.1895L7.28044 9.21975C6.98719 8.9265 6.51319 8.9265 6.21994 9.21975C5.92669 9.513 5.92669 9.987 6.21994 10.2802L8.46919 12.5295Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 14.25H4.5C4.08525 14.25 3.75 14.586 3.75 15C3.75 15.414 4.08525 15.75 4.5 15.75H13.5C13.9148 15.75 14.25 15.414 14.25 15C14.25 14.586 13.9148 14.25 13.5 14.25Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBar);
export default __webpack_public_path__ + "static/media/arrow-down-bar.568c17b9078037ef14e07ff06b9904b6.svg";
export { ForwardRef as ReactComponent };